import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'


// 门店
export function storeName() {
    return axios.request({
      url: urlObj.wss + 'wss-order/myWssOrder/getUserOptions',
      method: 'get',
    })
  }
  // 主表
  export function getSalesOrder(params,data) {
    return axios.request({
      url: urlObj.wss + 'wss-order/myWssOrder/getSalesOrder',
      method: 'post',
      params,
      data
    })
  }
    // 发货
    export function getshipments(data) {
      return axios.request({
        url: urlObj.wss + 'wss-order/afterSale/deliver',
        method: 'post',
        data
      })
    }

    // 主表(退款/退货)
    export function getSalesReturn(data) {
      return axios.request({
        url: urlObj.wss + 'wss-order/afterSale/listAfterSalesOrder',
        method: 'post',
        data
      })
    }
  // 发货
  export function orderDelivery(params) {
    return axios.request({
      url: urlObj.wss + 'wss-order/order/orderDelivery',
      method: 'put',
      params
    })
  }

  // 打印
  export function Print(id) {
    return axios.request({
      url: `${urlObj.wss}/wss-order/myWssOrder/printOrder/${id}`,
      method: 'get',
    })
  }